import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { useI18n } from '@/providers/i18n';
import { CameraIcon, PaletteIcon, PersonStandingIcon, SunIcon } from 'lucide-react';

type ToolChooserProps = {
  onSelect: (toolId: 'relight' | 'pose' | 'camera' | 'lut') => void;
};

export const ToolChooser = ({ onSelect }: ToolChooserProps) => {
  const { t } = useI18n();

  const items: Array<{
    id: 'relight' | 'pose' | 'camera' | 'lut';
    title: string;
    Icon: any;
  }> = [
    { id: 'relight', title: t('tool.relight.name'), Icon: SunIcon },
    { id: 'pose', title: t('tool.pose.name'), Icon: PersonStandingIcon },
    { id: 'camera', title: t('tool.camera.name'), Icon: CameraIcon },
    { id: 'lut', title: t('tool.lut.name'), Icon: PaletteIcon },
  ];

  return (
    <div className="h-full w-full p-5 flex flex-col">
      {/* 
        ReactFlow: keep cards easily clickable (no accidental node-drag), but still allow dragging
        the node from the outer padding area.
      */}
      <div className="text-xs text-muted-foreground mb-3 text-left select-none">
        {t('Please select a tool')}
      </div>
      <div className="nodrag grid flex-1 w-full grid-cols-2 gap-4 place-items-stretch">
        {items.map(({ id, title, Icon }) => (
          <Card
            key={id}
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onSelect(id);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                onSelect(id);
              }
            }}
            className="cursor-pointer select-none hover:border-primary/40 hover:shadow-md transition-colors"
          >
            <CardContent className="h-full w-full flex flex-col items-center justify-center gap-2 p-4">
              <div className="flex items-center justify-center size-10 rounded-lg bg-primary/10 text-primary">
                <Icon className="size-5" />
              </div>
              <div className="text-sm font-medium text-center leading-tight">{title}</div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};


